import { useCallback } from "react";
import { differenceInCalendarDays, parse } from "date-fns";
import useProfiler from "../../../hooks/useProfiler.js";
import { createTrackingUtils } from "../index.js";
const utils = createTrackingUtils({
    name: "flights_lve_web_price_alerts",
    defaultStage: 1,
    stages: {
        main: 1,
        desktop: 2,
        mdot: 3,
        subscriptionCreated: 4,
        bwShort: 5,
        bwMid: 6,
        bwLong: 7,
        appsNotificationFromWebAlert: 9
    },
    goals: {
        manageAlertsToastClick: 1
    }
});
export const trackSubscriptionCreatedWithBookingWindow = (departureDate) => {
    utils.stages.subscriptionCreated();
    const departure = parse(departureDate, "yyyy-MM-dd", new Date());
    const bookingWindowDays = differenceInCalendarDays(departure, new Date());
    if (bookingWindowDays >= 28) {
        utils.stages.bwLong();
    }
    else if (bookingWindowDays >= 11) {
        utils.stages.bwMid();
    }
    else if (bookingWindowDays >= 3) {
        utils.stages.bwShort();
    }
};
export const useTrackPriceAlertsWeb = () => {
    const { isDesktop } = useProfiler();
    return useCallback(() => {
        const variant = utils.trackWithDefaultStage();
        isDesktop() ? utils.stages.desktop() : utils.stages.mdot();
        return !!variant;
    }, [isDesktop]);
};
export default utils;
